import { ConfirmDialog } from "@nabble/ui";
import type { PendingUserActionState } from "./usePendingUserAction";

/** The confirmation dialogs of the actions that wait for the administrator's go-ahead. */
export function PendingUserActionDialogs({ state }: { state: PendingUserActionState }): React.JSX.Element {
  const { pending, run, cancel } = state;
  const status = pending?.kind === "status" ? pending : null;
  const disabling = status?.status === "DISABLED";
  return (
    <>
      <ConfirmDialog
        open={pending?.kind === "mfa"}
        tone="warning"
        icon="shield"
        title="Reset second factor"
        description={pending ? `${pending.user.displayName} will lose their authenticator app, passkeys and recovery codes, and will need to set them up again at their next sign-in.` : undefined}
        confirmLabel="Reset"
        onConfirm={run}
        onClose={cancel}
      />
      <ConfirmDialog
        open={status !== null}
        tone={disabling ? "danger" : "default"}
        icon={disabling ? "ban" : "power"}
        title={disabling ? "Disable user" : "Activate user"}
        description={
          status
            ? disabling
              ? `${status.user.displayName} won't be able to sign in and their open sessions will be closed. You can activate them again at any time.`
              : `${status.user.displayName} will be able to sign in again with their password and second factor.`
            : undefined
        }
        confirmLabel={disabling ? "Disable" : "Activate"}
        onConfirm={run}
        onClose={cancel}
      />
      <ConfirmDialog
        open={pending?.kind === "password"}
        icon="mail"
        title="Send password link"
        description={pending ? `We'll send ${pending.user.email} a single-use link to create a new password.` : undefined}
        confirmLabel="Send link"
        onConfirm={run}
        onClose={cancel}
      />
    </>
  );
}
